import React from 'react'
import { useI18n } from '../i18n'
import { Globe } from 'lucide-react'
import { componentScope } from '../lib/cssScope'
import { Select } from '@/components/ui/Select'

type Props = {
  /** Outline trigger — matches small outline buttons on enterprise cards. */
  appearance?: 'default' | 'outline'
}

const LanguageSwitcher: React.FC<Props> = ({ appearance = 'default' }) => {
  const { language, setLanguage, allowedLanguages, t } = useI18n() as any

  const allLanguages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
  ]

  // Filter languages based on user role
  const languages = allLanguages.filter(lang => allowedLanguages.includes(lang.code as any))

  return (
    <div
      className={`${componentScope('LanguageSwitcher')} flex items-center gap-2`}
      aria-label={t('a11y.languageSwitcher')}
      title={t('a11y.languageSwitcher')}
    >
      {appearance === 'default' ? (
        <Globe className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />
      ) : null}
      <Select
        options={languages.map((lang) => ({
          value: lang.code,
          label: `${lang.flag} ${lang.name}`,
        }))}
        value={language}
        onChange={(v) => {
          if (v != null) setLanguage(v as any)
        }}
        placeholder={t('a11y.languageSelect')}
        minWidth={appearance === 'outline' ? '7.5rem' : '9rem'}
        variant={appearance === 'outline' ? 'outline' : 'default'}
        data-testid="language-select"
      />
    </div>
  )
}

export default LanguageSwitcher